// productsData.js

const products = [
  {
    id: 1,
    name: "Luxe Leather Lounge Chair",
    category: "Chairs",
    section: "livingroom",
    material: "Fabric",
    style: "Modern",
    price: 299.99,
    imageUrl: "/assets/mat_lea_1.jpg",
    rating: 4.5,
    reviews: 87,
    description: "A comfortable and stylish lounge chair perfect for any modern living space. Crafted with high-quality fabric and sturdy wooden legs, it offers both durability and aesthetic appeal.",
    oldPrice: 350.00,
    images: [
      "/assets/mat_lea_1.jpg",
      "/assets/mat_lea_2.jpg",
      "/assets/mat_lea_3.jpg",
    ],
    colors: [
      { name: "Light Gray", hex: "#E0E0E0" },
      { name: "Charcoal", hex: "#424242" },
      { name: "Navy Blue", hex: "#1A237E" },
    ],
    features: [
      "Ergonomic design for maximum comfort",
      "Durable fabric upholstery",
      "Solid wood frame and legs",
      "Easy to assemble",
    ],
    materials: "The Modern Lounge Chair is constructed with a solid hardwood frame for superior stability. It is upholstered in a soft yet durable polyester blend fabric, and features high-density foam cushions for lasting comfort.",
  },
  {
    id: 2,
    name: "Artisan Oak Dining Table",
    category: "Tables",
    section: "livingroom",
    material: "Wood",
    style: "Traditional",
    price: 599.50,
    imageUrl: "/assets/mat_lea_2.jpg",
    rating: 4.8,
    reviews: 150,
    description: "An exquisite dining table designed to be the centerpiece of your dining room. Its elegant design and sturdy wood construction promise durability and timeless appeal.",
    oldPrice: 700.00,
    images: [
      "https://placehold.co/600x400/aaaaaa/333333?text=Dining+Table+1",
      "https://placehold.co/600x400/999999/333333?text=Dining+Table+2",
      "https://placehold.co/600x400/888888/333333?text=Dining+Table+3",
    ],
    colors: [
      { name: "Natural Wood", hex: "#8B4513" },
      { name: "Dark Walnut", hex: "#5C3317" },
    ],
    features: [
      "Solid wood construction",
      "Spacious tabletop for family gatherings",
      "Elegant design fits various decors",
      "Easy to clean surface",
    ],
    materials: "This dining table is crafted from sustainably sourced solid oak, known for its strength and beautiful grain. The surface is finished with a durable, water-resistant lacquer.",
  },
  {
    id: 'oslo-sofa', // Using string ID
    name: 'Oslo Sofa',
    category: 'Sofas',
    section: "livingroom",
    material: 'Fabric',
    style: 'Scandinavian',
    price: 1299.00,
    oldPrice: 1499.00,
    imageUrl: '/assets/mat_lea_3.jpg',
    rating: 4.8,
    reviews: 124,
    description: 'A timeless Scandinavian-inspired sofa featuring clean lines, premium upholstery, and solid oak legs. Perfect for modern living spaces seeking comfort without compromising on style.',
    images: [
      '/assets/mat_lea_1.jpg',
      '/assets/mat_lea_2.jpg',
      '/assets/mat_lea_3.jpg',
    ],
    colors: [
      { name: 'Gray', hex: '#A0A0A0' },
      { name: 'Black', hex: '#333333' },
      { name: 'White', hex: '#F0F0F0' },
      { name: 'Brown', hex: '#8B4513' },
    ],
    features: [
      'Premium upholstery with stain-resistant treatment',
      'Solid oak legs with natural finish',
      'High-density foam cushions for superior comfort',
      'Removable and washable covers',
      'Reinforced hardwood frame for durability',
    ],
    materials: `Crafted with premium materials, the Oslo Sofa combines functionality with timeless design. The frame is constructed from kiln-dried solid hardwood, ensuring stability and longevity. The upholstery features a high-performance polyester blend fabric (85% polyester, 15% nylon) that's both soft to the touch and highly durable. All cushions contain high-resilience foam cores wrapped in a layer of down alternative fill for the perfect balance of support and comfort.`,
  },
  {
    id: 4,
    name: "Industrial Metal Bar Stool Set",
    category: "Chairs", // Note: This is "Chairs", not "Bar Stools" as a category name
    section: "livingroom", // This product is in livingroom, not bar for now
    material: "Metal, Leather",
    style: "Industrial",
    price: 249.75,
    imageUrl: "/assets/mat_lea_2.jpg",
    rating: 4.2,
    reviews: 78,
    description: "A set of stylish and comfortable bar stools perfect for your kitchen island or home bar. Features a blend of sturdy metal and soft leather for a modern industrial look.",
    oldPrice: 300.00,
    images: [
      "/assets/mat_lea_2.jpg",
      "/assets/mat_me_1.jpg",
    ],
    colors: [
      { name: "Black", hex: "#000000" },
      { name: "Brown", hex: "#7B3F00" },
    ],
    features: [
      "Adjustable height",
      "Swivel function",
      "Padded leather seats",
      "Durable metal frame",
    ],
    materials: "The Bar Stool Set features a powder-coated steel frame for robust support. The seat is upholstered in high-quality faux leather, providing comfort and easy maintenance.",
  },
  {
    id: 'sectional-sofa-res', // CHANGED ID to be unique
    name: 'Contemporary Modular Sectional',
    category: 'Restaurant Sofas', // Renamed category to differentiate
    section: "restaurant",
    material: 'Fabric',
    style: 'Contemporary',
    price: 2500.00,
    oldPrice: 2800.00,
    imageUrl: "/assets/caf_bst_4.jpg",
    rating: 4.7,
    reviews: 95,
    description: 'A versatile modular sectional sofa that can be configured to fit any living space. Designed for ultimate comfort and flexibility, it features durable fabric and robust construction.',
    images: [
      "/assets/caf_bst_4.jpg",
      "/assets/Gallery1.png",
    ],
    colors: [
      { name: 'Beige', hex: '#F5F5DC' },
      { name: 'Dark Grey', hex: '#696969' },
    ],
    features: [
      'Modular design for flexible configurations',
      'Deep, plush seating for maximum comfort',
      'High-quality, easy-to-clean fabric',
      'Solid wood frame',
    ],
    materials: 'The Modular Sectional Sofa features a kiln-dried hardwood frame and high-resilience foam cushions. It is upholstered in a durable and soft chenille fabric (100% polyester).',
  },
  {
    id: 'media-unit-lv', // CHANGED ID to be unique and reflect section
    name: 'Scandinavian Walnut Media Console',
    category: 'Media Units',
    section: "livingroom", // This is correct, it was meant for livingroom
    material: 'Wood',
    style: 'Contemporary',
    price: 850.00,
    oldPrice: 950.00,
    imageUrl: 'https://images.pexels.com/photos/1866149/pexels-photo-1866149.jpeg?auto=compress&cs=tinysrgb&w=800&q=80', // Placeholder
    rating: 4.5,
    reviews: 70,
    description: 'A sleek and functional media unit designed to complement modern living rooms, offering ample storage and cable management.',
    images: [
      'https://images.pexels.com/photos/1866149/pexels-photo-1866149.jpeg?auto=compress&cs=tinysrgb&w=1200&q=80',
    ],
    colors: [
      { name: 'Walnut', hex: '#5C4033' },
      { name: 'Black', hex: '#000000' },
    ],
    features: [
      'Integrated cable management',
      'Multiple storage compartments',
      'Durable and scratch-resistant surface',
      'Easy assembly',
    ],
    materials: 'Constructed from high-quality MDF with a durable wood veneer finish and sturdy metal legs.',
  },
  {
    id: 100,
    name: "Royal Velvet Dining Chair",
    category: "Dining Chairs",
    section: "bedroom", // This was 'bedroom', but is it used in bedrooms? Reconsider category.
    material: "Velvet & Metal",
    style: "Modern",
    price: 220,
    oldPrice: 250.00,
    imageUrl: "/assets/caf_fd_1.jpg",
    rating: 4.7,
    reviews: 85,
    description: "An elegant and comfortable dining chair featuring a velvet-upholstered seat and sturdy metal legs.",
    images: [
      "/assets/caf_fd_2.jpg",
      "/assets/caf_fd_3.jpg",
    ],
    colors: [
      { name: "Royal Blue", hex: "#4169E1" },
      { name: "Dark Green", hex: "#006400" },
      { name: "Deep Red", hex: "#8B0000" },
    ],
    features: [
      "Soft-touch velvet upholstery",
      "Durable metal legs",
      "Ergonomic seat design",
    ],
    materials: "Constructed with premium velvet fabric and reinforced steel legs for long-lasting durability.",
  },
  {
    id: 102,
    name: "Heritage Oak Dining Table",
    category: "Dining Tables",
    section: "bedroom", // As above, dining furniture in bedroom section?
    material: "Solid Wood",
    style: "Classic",
    price: 800,
    oldPrice: 950.00,
    imageUrl: "/assets/caf_fd_2.jpg",
    rating: 4.8,
    reviews: 120,
    description: "A timeless solid wood dining table built to last for generations, offering a warm and elegant style.",
    images: [
      "/assets/caf_fd_3.jpg",
      "/assets/caf_bst_1.jpg",
    ],
    colors: [
      { name: "Natural Oak", hex: "#D2B48C" },
      { name: "Walnut Brown", hex: "#5C3317" },
    ],
    features: [
      "High-quality solid wood",
      "Spacious tabletop for family meals",
      "Easy-to-clean surface",
    ],
    materials: "Made from 100% solid oak wood, finished with a protective lacquer coating.",
  },
  {
    id: 103,
    name: "Comfort Cloud Lounge Sofa",
    category: "Lounge Furniture",
    section: "bedroom", // Lounge furniture in bedroom section?
    material: "Fabric & Wood",
    style: "Contemporary",
    price: 650,
    oldPrice: 750.00,
    imageUrl: "/assets/caf_bst_1.jpg",
    rating: 4.6,
    reviews: 95,
    description: "A cozy and stylish lounge sofa offering supreme comfort, ideal for relaxation in modern living spaces.",
    images: [
      "/assets/caf_caf_1.jpg",
      "/assets/caf_caf_2.jpg",
    ],
    colors: [
      { name: "Beige", hex: "#F5F5DC" },
      { name: "Slate Gray", hex: "#708090" },
    ],
    features: [
      "Soft, plush cushions",
      "Solid wooden legs",
      "High-quality fabric upholstery",
    ],
    materials: "Crafted with a reinforced wooden frame and high-density foam cushions for durability and comfort.",
  },
  {
    id: 104,
    name: "Bohemian Rattan Lounge Chair",
    category: "Outdoor Seating",
    section: "bedroom", // Outdoor seating in bedroom section? Reconsider this.
    material: "Rattan & Metal",
    style: "Bohemian",
    price: 300,
    oldPrice: 350.00,
    imageUrl: "/assets/caf_otd_1.jpg",
    rating: 4.5,
    reviews: 70,
    description: "A stylish and durable outdoor lounge chair designed for comfort and relaxation in outdoor spaces.",
    images: [
      "/assets/caf_otd_2.jpg",
      "/assets/caf_otd_3.jpg",
    ],
    colors: [
      { name: "Sand Beige", hex: "#C2B280" },
      { name: "Dark Brown", hex: "#654321" },
    ],
    features: [
      "Weather-resistant rattan",
      "Lightweight metal frame",
      "Comfortable reclining seat",
      "Suitable for patios and gardens", // Added a more relevant feature
    ],
    materials: "Built with weather-resistant rattan and a sturdy powder-coated steel frame for outdoor use.",
  },
  {
    id: 201,
    name: "Premium Restaurant Dining Chair", // Renamed for clarity in restaurant section
    category: "Restaurant Chairs", // Consistent category name
    section: "restaurant",
    material: "Velvet & Metal",
    style: "Modern",
    price: 220,
    oldPrice: 250.00,
    imageUrl: "/assets/caf_fd_3.jpg",
    rating: 4.7,
    reviews: 85,
    description: "An elegant and comfortable dining chair featuring a velvet-upholstered seat and sturdy metal legs, suitable for commercial spaces.",
    images: [
      "/images/luxury-dining-chair-1.jpg",
      "/images/luxury-dining-chair-2.jpg",
      "/images/luxury-dining-chair-3.jpg",
    ],
    colors: [
      { name: "Royal Blue", hex: "#4169E1" },
      { name: "Dark Green", hex: "#006400" },
      { name: "Deep Red", hex: "#8B0000" },
    ],
    features: [
      "Soft-touch velvet upholstery",
      "Durable metal legs",
      "Ergonomic seat design",
      "Stackable for easy storage", // Relevant for restaurant
    ],
    materials: "Constructed with premium velvet fabric and reinforced steel legs for long-lasting durability in commercial settings.",
  },
  {
    id: 202,
    name: "Professional Oak Dining Table", // Renamed
    category: "Restaurant Tables", // Consistent category name
    section: "restaurant",
    material: "Solid Wood",
    style: "Classic",
    price: 800,
    oldPrice: 950.00,
    imageUrl: "/assets/caf_bst_2.jpg",
    rating: 4.8,
    reviews: 120,
    description: "A timeless solid wood dining table built to last for generations, offering a warm and elegant style, ideal for restaurants.",
    images: [
      "/images/wooden-dining-table-1.jpg",
      "/images/wooden-dining-table-2.jpg",
    ],
    colors: [
      { name: "Natural Oak", hex: "#D2B48C" },
      { name: "Walnut Brown", hex: "#5C3317" },
    ],
    features: [
      "High-quality solid wood",
      "Spacious tabletop for family meals",
      "Easy-to-clean surface",
      "Resistant to heavy commercial use", // Relevant for restaurant
    ],
    materials: "Made from 100% solid oak wood, finished with a protective lacquer coating.",
  },
  {
    id: 203,
    name: "Modular Restaurant Booth Seating", // Renamed
    category: "Restaurant Booths", // Consistent category name
    section: "restaurant",
    material: "Fabric & Wood",
    style: "Contemporary",
    price: 1650, // Price adjusted for a booth
    oldPrice: 1750.00,
    imageUrl: "/assets/caf_caf_1.jpg",
    rating: 4.6,
    reviews: 95,
    description: "Modular booth seating designed for restaurants, offering comfort and customizable layouts.",
    images: [
      "/assets/caf_caf_1.jpg",
      "/assets/caf_caf_2.jpg",
    ],
    colors: [
      { name: "Beige", hex: "#F5F5DC" },
      { name: "Slate Gray", hex: "#708090" },
    ],
    features: [
      "Modular design for flexible configurations",
      "Durable upholstery for high traffic areas",
      "Comfortable seating for patrons",
      "Easy to clean",
    ],
    materials: "Crafted with a reinforced wooden frame and high-density foam cushions for durability and comfort in commercial settings.",
  },
  {
    id: 204,
    name: "Weather-Resistant Patio Seating", // Renamed
    category: "Outdoor Seating",
    section: "restaurant",
    material: "Rattan & Metal",
    style: "Bohemian",
    price: 300,
    oldPrice: 350.00,
    imageUrl: "/assets/caf_otd_2.jpg",
    rating: 4.5,
    reviews: 70,
    description: "Weather-resistant outdoor seating ideal for restaurant patios and outdoor dining areas.",
    images: [
      "/assets/caf_otd_1.jpg",
      "/assets/caf_otd_2.jpg",
    ],
    colors: [
      { name: "Sand Beige", hex: "#C2B280" },
      { name: "Dark Brown", hex: "#654321" },
    ],
    features: [
      "Weather-resistant rattan",
      "Lightweight metal frame",
      "Designed for commercial outdoor use",
      "UV protection",
    ],
    materials: "Built with weather-resistant rattan and a sturdy powder-coated steel frame for outdoor use.",
  },
  {
    id: 301,
    name: "Industrial Swivel Bar Stool",
    category: "Bar Stools",
    section: "bar",
    material: "Metal & Leatherette",
    style: "Industrial",
    price: 180,
    imageUrl: "https://images.pexels.com/photos/5953598/pexels-photo-5953598.jpeg?auto=compress&cs=tinysrgb&w=800&q=80",
    rating: 4.4,
    reviews: 60,
    description: "A sleek and durable bar stool with a comfortable leatherette seat and sturdy metal frame, perfect for any bar or counter.",
    oldPrice: 200.00,
    images: ["https://images.pexels.com/photos/5953598/pexels-photo-5953598.jpeg?auto=compress&cs=tinysrgb&w=1200&q=80"],
    colors: [{ name: "Black", hex: "#000000" }],
    features: ["Adjustable height", "Swivel function", "Durable leatherette"],
    materials: "Powder-coated steel base and high-quality synthetic leather seat."
  },
  {
    id: 302,
    name: "Rustic Walnut Bar Counter",
    category: "Bar Counters",
    section: "bar",
    material: "Solid Wood & Stone",
    style: "Rustic",
    price: 2500,
    imageUrl: "https://images.pexels.com/photos/5490965/pexels-photo-5490965.jpeg?auto=compress&cs=tinysrgb&w=800&q=80",
    rating: 4.9,
    reviews: 45,
    description: "A rustic custom-built bar counter featuring solid wood and a stone top, ideal for a unique bar setup.",
    oldPrice: 2800.00,
    images: ["https://images.pexels.com/photos/5490965/pexels-photo-5490965.jpeg?auto=compress&cs=tinysrgb&w=1200&q=80"],
    colors: [{ name: "Walnut", hex: "#3D2B1F" }],
    features: ["Handcrafted", "Natural Finish", "Spacious Countertop"],
    materials: "Reclaimed walnut wood and polished granite top."
  },
  {
    id: 303,
    name: "Premium Cognac Leather Bar Chair",
    category: "Bar Stools",
    section: "bar",
    material: "Full Grain Leather",
    style: "Luxury",
    price: 350,
    imageUrl: "https://images.pexels.com/photos/5531303/pexels-photo-5531303.jpeg?auto=compress&cs=tinysrgb&w=800&q=80",
    rating: 4.8,
    reviews: 32,
    description: "Ultra-comfortable bar chair with premium leather upholstery and brass accents.",
    images: ["https://images.pexels.com/photos/5531303/pexels-photo-5531303.jpeg?auto=compress&cs=tinysrgb&w=1200&q=80"],
    colors: [{ name: "Cognac", hex: "#954A2D" }],
    features: ["Ergonomic Backrest", "Brass Footrest", "Premium Leather"],
    materials: "Italian full grain leather and solid oak legs with brass caps."
  },
  {
    id: 304,
    name: "Carrara Marble Brass Bar Table",
    category: "Bar Counters",
    section: "bar",
    material: "Marble & Brass",
    style: "Contemporary",
    price: 1200,
    imageUrl: "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=800&q=80",
    rating: 4.7,
    reviews: 18,
    description: "A stunning marble top bar table with a minimalist brass base.",
    images: ["https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1200&q=80"],
    colors: [{ name: "White/Gold", hex: "#FFFFFF" }],
    features: ["Carrara Marble", "Brass Finish", "Sleek Design"],
    materials: "Natural Carrara marble and antique brass finish steel."
  },
  {
    id: 305,
    name: "LED Illuminated Wine Display Rack",
    category: "Storage & Display",
    section: "bar",
    material: "Steel & Walnut",
    style: "Industrial",
    price: 850,
    imageUrl: "https://images.pexels.com/photos/14201458/pexels-photo-14201458.jpeg?auto=compress&cs=tinysrgb&w=800&q=80",
    rating: 4.6,
    reviews: 24,
    description: "Modular wine display rack with integrated LED lighting.",
    images: ["https://images.pexels.com/photos/14201458/pexels-photo-14201458.jpeg?auto=compress&cs=tinysrgb&w=1200&q=80"],
    features: ["LED Backlighting", "Modular Setup", "Tempered Glass"],
    materials: "Cold-rolled steel and solid walnut accents."
  },
  {
    id: 306,
    name: "Art Deco Ebony Bar Cabinet",
    category: "Bar Cabinets",
    section: "bar",
    material: "Ebony Wood",
    style: "Art Deco",
    price: 1800,
    imageUrl: "https://images.pexels.com/photos/5531548/pexels-photo-5531548.jpeg?auto=compress&cs=tinysrgb&w=800&q=80",
    rating: 4.9,
    reviews: 12,
    description: "Intricately designed bar cabinet with mirrored interior and specialized storage.",
    images: ["https://images.pexels.com/photos/5531548/pexels-photo-5531548.jpeg?auto=compress&cs=tinysrgb&w=1200&q=80"],
    features: ["Mirrored Backing", "Glass Racks", "Lockable Doors"],
    materials: "Polished ebony wood and crystal handles."
  },
  {
    id: 401,
    name: "Nordic Beechwood Cafe Table",
    category: "Cafe Tables",
    section: "cafe",
    material: "Metal & Wood",
    style: "Minimalist",
    price: 150,
    imageUrl: "/assets/caf_bst_2.jpg",
    rating: 4.3,
    reviews: 55,
    description: "A stylish and compact cafe table with a minimalist design, perfect for small cafes and bistros.",
    oldPrice: 170.00,
    images: [
      "https://placehold.co/600x400/e0e0e0/333333?text=Cafe+Table+1",
      "https://placehold.co/600x400/d0d0d0/333333?text=Cafe+Table+2",
    ],
    colors: [
      { name: "White", hex: "#FFFFFF" },
      { name: "Black", hex: "#000000" },
    ],
    features: [
      "Space-saving design",
      "Durable metal base",
      "Easy to clean wooden top",
      "Suitable for indoor and outdoor use",
    ],
    materials: "Features a powder-coated steel base and a solid beechwood tabletop.",
  },
  {
    id: 402,
    name: "Stackable Industrial Cafe Chair",
    category: "Cafe Chairs",
    section: "cafe",
    material: "Metal",
    style: "Industrial",
    price: 90,
    imageUrl: "/assets/caf_caf_1.jpg",
    rating: 4.1,
    reviews: 70,
    description: "A robust and stylish industrial-style cafe chair, perfect for adding an edgy touch to your cafe interior.",
    oldPrice: 100.00,
    images: [
      "https://placehold.co/600x400/ccccce/333333?text=Cafe+Chair+1",
      "https://placehold.co/600x400/bbbbbe/333333?text=Cafe+Chair+2",
    ],
    colors: [
      { name: "Gunmetal", hex: "#5A5A5A" },
      { name: "Bronze", hex: "#CD7F32" },
    ],
    features: [
      "Durable steel construction",
      "Stackable design",
      "Comfortable backrest",
      "Suitable for high-traffic areas",
    ],
    materials: "Crafted from heavy-gauge steel with a durable powder-coated finish.",
  },
];

export default products;